import axios from 'axios';

import {CLEAR_CURRENT_PROFILE, GET_ERRORS, SET_CURRENT_USER, SET_INSTALLER, UPDATE_INSTALLER, RELOAD_PROFILE} from "./types";

//Login - Get User Token

export const loginUser = userData => dispatch => {
    axios
        .post(`${process.env.REACT_APP_API_URL_BASE}/api/login/login`, userData)
        .then( res => {
            if (res.data.error) {
                dispatch(setErrors(res.data.error));
            } else {
                localStorage.setItem('sessionToken', res.data.data.session_token);

                axios
                    .get(`${process.env.REACT_APP_API_URL_BASE}/api/installer/me`)
                    .then(res2 => {
                        if(!res2.data.data.shop){
                            dispatch(setErrors("No shop associated with user"));
                        }

                        if (res2.data.error) {
                            dispatch(setErrors(res2.data.error));
                        } else {
                            localStorage.setItem('user', JSON.stringify(res.data));
                            localStorage.setItem('shop', JSON.stringify(res2.data.data.shop));
                            dispatch(setInstaller(res2.data.data.shop));
                            dispatch(setCurrentUser(res.data));
                        }
                    });
            }
        })
        .catch(err => {
            dispatch({
                type: GET_ERRORS,
                payload: err
            })
        });
}


export const getInstallerInfo = userData => dispatch => {
    axios
        .get(`${process.env.REACT_APP_API_URL_BASE}/api/installer/me`, {params: userData})
        .then(res => {
            console.log(res);
            if (res.data.error) {
                dispatch(setErrors(res.data.error));
            } else {
                dispatch(setInstaller(res.data));
            }
        })
        .catch( err => {
            dispatch({
                type: GET_ERRORS,
                payload: err
            })
        });
}

export const updateProfile = userData => dispatch => {
    axios
        .post(`${process.env.REACT_APP_API_URL_BASE}/api/installer/update`, userData)
        .then( res =>{
            if (res.data.error) {
                dispatch(setErrors(res.data.error));
            } else {
                localStorage.setItem('shop', JSON.stringify(res.data.data.partner_shop));
                dispatch(updateInstaller(res.data))
            }
        })
        .catch(err => {
            dispatch({
                type: GET_ERRORS,
                payload: err
            })
        });
}


    export const reloadProfile = userData => dispatch => {
    axios
        .get(`${process.env.REACT_APP_API_URL_BASE}/api/user/me`, {params: userData})
        .then( res => {
            if (res.data.error) {
                dispatch(setErrors(res.data.error));
            } else {
                //dispatch(setCurrentUser(res.data));
                axios
                    .get(`${process.env.REACT_APP_API_URL_BASE}/api/installer/me`)
                    .then(res2 => {
                        if (res2.data.error) {
                            dispatch(setErrors(res2.data.error));
                        } else {
                            dispatch(setInstaller(res2.data.data.shop));
                            dispatch(setCurrentUser(res.data));
                        }
                    });
            }
        })
        .catch(err => {
            dispatch({
                type: GET_ERRORS,
                payload: err
            })
        });
}
// Log user out
export const logoutUser = () => dispatch => {
    // Remove token from localStorage
    //localStorage.removeItem('sessionToken');
    localStorage.clear();
    // Set current user to {} which will also set isAuthenticated to false
    dispatch(clearCurrentUser());
};

export const setErrors = err => {
    return {
        type: GET_ERRORS,
        payload: err
    };
}

// Set logged in user
export const setCurrentUser = decoded => {
    return {
        type: SET_CURRENT_USER,
        payload: decoded
    };
};

export const setInstaller = installer => {
    return {
        type: SET_INSTALLER,
        payload: installer
    }
}
const updateInstaller = installer => {
    return {
        type: UPDATE_INSTALLER,
        payload: installer
    }
}

export const clearCurrentUser = params => {
    return {
        type: CLEAR_CURRENT_PROFILE,
        payload: null
    }
}

export const getCurrentProfile = params => {
    return {
        type: RELOAD_PROFILE,
        payload: params
    }
}


// WEBPACK FOOTER //
// ./src/actions/authActions.jsx